import GatsbyBackgroundImageWrapperFluid from '../GatsbyBackgroundImageWrapperFluid';

import styled from '../../../utils/styling/styled';

export const ImageFluid = styled(GatsbyBackgroundImageWrapperFluid)`
  width: 100%;
`;
